import { get, post, patch } from './client.js';

export const getBackupSettings = (orgId) => get(`/orgs/${orgId}/settings`);
export const getBackupHistory = (orgId) => get(`/orgs/${orgId}/settings/backup/history`);
export const updateBackup = (orgId, body) => patch(`/orgs/${orgId}/settings/backup`, body);
export const triggerBackup = (orgId) => post(`/orgs/${orgId}/settings/backup/trigger`, {});
export const requestRestore = (orgId) => post(`/orgs/${orgId}/settings/backup/restore`, {});
